// Simple type for identifying each tab
export type TabId = 'drawings' | 'lineMap' | '3dModel' | 'nodeSummary';

// Basic tab configuration
export interface Tab {
    id: TabId;
    title: string;
    isVisible: boolean;
    order: number;
}

// Default configuration for all tabs
export const DEFAULT_TABS: Tab[] = [
    { id: 'drawings', title: 'Drawings', isVisible: true, order: 0 },
    { id: 'lineMap', title: 'Line Map', isVisible: true, order: 1 },
    { id: '3dModel', title: '3D Model', isVisible: true, order: 2 },
    { id: 'nodeSummary', title: 'Node Summary', isVisible: true, order: 3 }
];
